export function openShippingCountryModal() {
    $('#modalCountry .modalCountryHint').hide();
    $('#modalCountry').modal('show');
    var currentCountryCode = $("#currentCountryCode").attr("data-current-country-code");
    $("." + currentCountryCode).addClass("active");
}